/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityReferenceIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityReferenceIdQueryOperator");
    }

    getFixupPrototypeFunction() { return VulnerabilityReferenceIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityReferenceIdQueryOperator>): VulnerabilityReferenceIdQueryOperator {
        let obj = Object.assign(new VulnerabilityReferenceIdQueryOperator(), model);
        VulnerabilityReferenceIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityReferenceIdQueryOperator>): VulnerabilityReferenceIdQueryOperator {
        if (!model) return null;
        return VulnerabilityReferenceIdQueryOperator.newInstance(<VulnerabilityReferenceIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityReferenceIdQueryOperator) {
        if (!obj) return;

        models.VulnerabilityReferenceIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityReferenceIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityReferenceIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Vulnerability IDs to include
     */
    vulnerability_reference_ids: Array<string>;

}
